import { ALPHANUMERIC_CHAR_TYPES } from "@/utils/checkCharTypeValidator";
import { validator } from "@/utils/validator";

export const nationalitySchema = validator.object().shape({
  regionId: validator.string().emptyToNull().label("地域").required(),
  nationalityName: validator.string().emptyToNull().label("名称").required(),
  engNationalityName: validator.string().emptyToNull().latinsOnly().label("名称（英語）").required(),
  nationalRenewVisaCsvCode: validator
    .string()
    .emptyToNull()
    .autoTransformToHalfWidth()
    .isValidCheckCharType(ALPHANUMERIC_CHAR_TYPES)
    .length(3)
    .label("期間更新CSVのコード")
    .required(),
  nationalityCode: validator
    .string()
    .emptyToNull()
    .autoTransformToHalfWidth()
    .isValidCheckCharType(ALPHANUMERIC_CHAR_TYPES)
    .length(3)
    .label("随時届出CSVのコード")
    .notRequired(),
});
